import { render } from "./Geet.vue?vue&type=template&id=0fb5e66d&scoped=true"
import script from "./Geet.vue?vue&type=script&lang=js"
export * from "./Geet.vue?vue&type=script&lang=js"

import "./Geet.vue?vue&type=style&index=0&id=0fb5e66d&lang=scss&scoped=true"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb5e66d"]])

export default __exports__